import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-import-calibration',
  templateUrl: './import-calibration.component.html',
  styleUrls: ['./import-calibration.component.scss']
})
export class ImportCalibrationComponent implements OnInit {

  selectBaselineProjectId: number;
  selectedBaselineRunId: number;
  baselineProjectName: string;
  selectedBaselineProjectRunId: string;

  constructor(public dialogRef: MatDialogRef<ImportCalibrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedBaselineProjectId: number, selectedBaselineRunId: number, baseLineRuns: any }) { }

  ngOnInit(): void {
    this.selectBaselineProjectId = this.data.selectedBaselineProjectId;
    this.selectedBaselineRunId = this.data.selectedBaselineRunId;  
    this.selectedBaselineProjectRunId = `${this.selectBaselineProjectId}-${this.selectedBaselineRunId}`;  
    // setting projectId-runId as the id field for the dropdown selections
    this.data.baseLineRuns.forEach(it=>{
      it['id']= `${it.project_id}-${it.run_id}`;
    });
    this.baselineProjectName = this.selectBaselineProjectId && this.selectedBaselineRunId ? 
      this.data.baseLineRuns.filter(it=> it.project_id == this.selectBaselineProjectId && it.run_id == this.selectedBaselineRunId)[0].project_name
      : 'Name of the project';   
  }

  selectBaselineRun(){
    const selectedBaseline = this.data.baseLineRuns.filter(it=> it.id == this.selectedBaselineProjectRunId);
    if(selectedBaseline?.length>0){
      this.selectBaselineProjectId = selectedBaseline[0].project_id;
      this.selectedBaselineRunId = selectedBaseline[0].run_id;    
      this.baselineProjectName = selectedBaseline[0].project_name; 
    }
  }

  saveBaselineRun(){
    this.dialogRef.close({
      selectedBaselineProjectId: this.selectBaselineProjectId,
      selectedBaselineRunId: this.selectedBaselineRunId
    });
  }

  disableImport(){
    return !this.selectedBaselineRunId;
  }

}
